(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["nci-clinical-trials-listing-app"] = factory();
	else
		root["nci-clinical-trials-listing-app"] = factory();
})(this, function() {
return 